module.exports = __webpack_public_path__ + "static/media/shop-history-active-dark-icon.2469ef42.svg";